// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_63-0";
export var orangeButton = "_63-1";